export default __webpack_public_path__ + "assets/bec186c72555f89bf24db9a8dd3ce104.jpg";